import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import Icon from 'Core/Components/Icon';
import Submit from 'RLX/Forms/Submit';

class ButtonGroup extends React.Component {
  constructor (props) {
    super(props);
    this.renderButton = this.renderButton.bind(this);
    this.getButtonContent = this.getButtonContent.bind(this);
    this.getButtonAttributes = this.getButtonAttributes.bind(this);
  }

  getButtonContent ({ text, icon, iconSide = 'left' }) {
    return (
      <Fragment>
        {!icon || iconSide !== 'left' ? null : <Icon fa={icon + ' left'} />}
        {text}
        {!icon || iconSide !== 'right' ? null : <Icon fa={icon + ' right'} />}
      </Fragment>
    );
  }

  getButtonAttributes (button = {}) {
    const defaults = {
      name: '',
      type: 'button',
      className: null,
      disabled: false,
      autoFocus: false
    };
    const keys = Object.keys(defaults);
    const all = { ...defaults, ...button };
    return Object
      .keys(all)
      .filter(key => keys.includes(key))
      .reduce(( out, key ) => {
        const value = all[key];
        return { ...out, [key]: value };
      }, {});
  }

  renderButton (button, index) {
    const { when, url, submit } = button;
    const content = this.getButtonContent(button);
    const attrs = this.getButtonAttributes(button);

    const Button = ({ children }) => {
      const submittable = (typeof when !== 'undefined' ? when : true);
      return submit
        ? <Submit {...attrs} when={submittable}>{children}</Submit>
        : <button {...attrs}>{children}</button>
    };

    const Wrapper = ({ children }) => {
      return url
        ? <Link to={url}>{children}</Link>
        : <Fragment>{children}</Fragment>
    };

    return (
      <Wrapper key={index}>
        <Button>
          {content}
        </Button>
      </Wrapper>
    );
  }

  render () {
    const { buttons } = this.props;
    const children = buttons.map(this.renderButton);
    return <div className="ButtonGroup" children={children} />
  }
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ButtonGroup.jsx